module.exports = __webpack_public_path__ + "img/bulle-employeur.46b38aa.png";